export default __webpack_public_path__ + "static/media/office_karier.acb1048f.png";